import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CalendarHeart02 = function CalendarHeart02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 10H3m18 1.5V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22h4.7M16 2v4M8 2v4m9.4976 9.7119c-.6998-.7791-1.8667-.9887-2.7435-.2752s-1.0002 1.9063-.3116 2.7501S17.4976 21 17.4976 21s2.3666-1.9694 3.0551-2.8132c.6886-.8438.5802-2.0442-.3116-2.7501s-2.0437-.5039-2.7435.2752"
    })
  }));
};
export default CalendarHeart02;